import { http } from "./http.js";
import { ui } from "./ui.js";

export const uiEvents = {

    mixpanel: {
        addEvent: async (eventName, action, aditionalProperties = null) => {
            const endpoint = window.appvars.services.mixpanel.addEvent;

            await http.post(endpoint, {
                event: eventName,
                action: action,
                aditionalProperties: aditionalProperties,
            },
            {
                errorHandler: (responseError, options) => {
                    responseError.json().then((errorJson) => {
                        console.warn(`MixPanel Error - ${errorJson.error.message} (${errorJson.error.code})`);
                    });
                }
            })
        }
    },

    toolbar: {
        setAddNewAppBtn: async () => {

            const btnAddNewApp = document.getElementById("aNewMenuCreateProcess");
            if (!btnAddNewApp) return;

            btnAddNewApp.addEventListener("click",
                async () => {

                    const data = await http.post(window.appvars.services.flows.addroute);

                    if (!data.success) return;

                    const url = data.success.url;
                    const size = data.success.size;

                    if (!size) {
                        window.open(data.success.url);
                        return;
                    }
                    ui.modal(url, size);

                });
        }
    },

    topbar: {
        setClickHelpMenuOption: async () => {
            let optHelpMenu = document.querySelectorAll('[data-menu-desc]');
            if (!optHelpMenu || !optHelpMenu.length) return;

            optHelpMenu.forEach((optMenu) => {
                optMenu.addEventListener("click",
                    async () => {
                        let aditionalProperties = {
                            help_menu_item: optMenu.getAttribute('data-menu-desc')
                        }
                        uiEvents.mixpanel.addEvent("Central de ajuda", "Click", aditionalProperties);
                    });
            });
        },

        searchBoxValue: "",

        setChangeSearchBox: async () => {
            let searchBox = document.getElementById("inpSearch");
            let timeout;
            if (!searchBox) return;

            searchBox.addEventListener("input",
                async () => {
                    if (searchBox.value.length < 3) return;

                    uiEvents.topbar.searchBoxValue = searchBox.value;
                    let aditionalProperties = {
                        search_box_text: uiEvents.topbar.searchBoxValue
                    }
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        uiEvents.mixpanel.addEvent("Pesquisa global", "Click", aditionalProperties);
                        uiEvents.topbar.setClickSearchBoxOption(searchBox);
                        uiEvents.topbar.setClickSearchBoxOptionMore(searchBox);
                    }, 1000);
                });
        },

        setClickSearchBoxOption: async (searchBox) => {
            let searchBoxOption = searchBox.parentElement.querySelectorAll('a.dropdown-item');
            if (!searchBoxOption) return;

            searchBoxOption.forEach((opt) => {
                opt.addEventListener("click",
                    async (event) => {
                        let categorySearchBox = event.target.closest('.dropdown-group') ? event.target.closest('.dropdown-group').getAttribute('data-id') : '';
                        let aditionalProperties = {
                            search_box_text: uiEvents.topbar.searchBoxValue,
                            search_box_category: categorySearchBox,
                            search_box_result: event.target.innerText
                        }
                        uiEvents.mixpanel.addEvent("Módulo pesquisado", "Click", aditionalProperties);
                    });
            });
        },

        setClickSearchBoxOptionMore: async (searchBox) => {
            let searchBoxOptionMore = searchBox.parentElement.querySelectorAll('a.dropdown-item-more');
            if (!searchBoxOptionMore) return;

            searchBoxOptionMore.forEach((opt) => {
                opt.removeEventListener("click", uiEvents.topbar.clickSearchBoxOptionMore);
                opt.addEventListener("click", uiEvents.topbar.clickSearchBoxOptionMore);
            });
        },
            
        clickSearchBoxOptionMore: async (event) => {
            let categorySearchBox = event.target.closest('.dropdown-group') ? event.target.closest('.dropdown-group').getAttribute('data-id') : '';
            let aditionalProperties = {
                search_box_text: uiEvents.topbar.searchBoxValue,
                search_box_category: categorySearchBox,
                search_box_result: "Veja mais"
            };
            uiEvents.mixpanel.addEvent('Módulo pesquisado', 'Click', aditionalProperties);
        },

        setClickAIChat: async () => {
            const btnOpenAIChat = document.getElementById("open-zai-chat");
            const container = document.getElementById("modal-chat-zai-content");
            if (!btnOpenAIChat || !container) return;

            const src = btnOpenAIChat.getAttribute('data-src');
            btnOpenAIChat.addEventListener("click", () => { uiEvents.topbar.createIframe(src, container); });
        },

        createIframe: (src, container) => {
            const id = "temp-iframe-zai";
            if (document.getElementById(id)) return;

            const iframe = document.createElement("iframe");
            iframe.id = id;
            iframe.classList.add("modal-iframe", "modal-iframe-show");
            iframe.onload = () => bsml.showModalFrame(iframe);
            iframe.src = src;
            iframe.width = "100%";
            iframe.height = "100%";
            iframe.frameBorder = "0";

            container.append(iframe);
        }
    },

    flowExecute: {

        setViewAllFilesLinkEvent: async () => {
            const lnkViewAllFiles = document.getElementById("lnkViewAllFiles");
            if (!lnkViewAllFiles) return;

            let aditionalProperties = {
                feature_name: "Anexos",
                application: "Zeev Core",
                application_page: "Executar tarefas"
            }

            lnkViewAllFiles.addEventListener("click",
                async () => {
                    uiEvents.mixpanel.addEvent("Visualizar todos os arquivos", "Click", aditionalProperties);
                }
            );
        },

        setDownloadAllFilesLinkEvent: async () => {
            const lnkDownloadAllFiles = document.getElementById("lnkDownloadAllFiles");
            if (!lnkDownloadAllFiles) return;

            let aditionalProperties = {
                feature_name: "Anexos",
                application: "Zeev Core",
                application_page: "Executar tarefas"
            }

            lnkDownloadAllFiles.addEventListener("click",
                async () => {
                    uiEvents.mixpanel.addEvent("Baixar todos os arquivos", "Click", aditionalProperties);
                }
            );
        }

    }
}

document.addEventListener("DOMContentLoaded", () => {
    
    uiEvents.toolbar.setAddNewAppBtn();
    uiEvents.topbar.setClickHelpMenuOption();
    uiEvents.topbar.setChangeSearchBox();
    uiEvents.flowExecute.setViewAllFilesLinkEvent();
    uiEvents.flowExecute.setDownloadAllFilesLinkEvent();
    uiEvents.topbar.setClickAIChat();
});